import api, { transformRequest, transformResponse } from "services/api";

export const udfApi = api
  .enhanceEndpoints({ addTagTypes: ["UserUdfCustomField", "UserUdfCustomFieldDromoSchema"] })
  .injectEndpoints({
    endpoints: (build) => ({
      addUserUdfCustomField: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/user-custom-fields/create/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "UserUdfCustomField", id: "LIST" }],
      }),
      fetchAllUserUdfCustomFields: build.query({
        query: () => `/api/v1/core/user-custom-fields/`,
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? // successful query
              [
                ...results.map(({ id }) => ({ type: "UserUdfCustomField", id })),
                { type: "UserUdfCustomField", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'UserUdfCustomField', id: 'LIST' }` is invalidated
              [{ type: "UserUdfCustomField", id: "LIST" }],
      }),
      fetchAllUserUdfCustomFieldsDromoSchema: build.query({
        query: () => `/api/v1/core/user-custom-fields/dromo-schema/`,
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? // successful query
              [{ type: "UserUdfCustomFieldDromoSchema", id: "LIST" }]
            : // an error occurred, but we still want to refetch this query when `{ type: 'UserUdfCustomFieldDromoSchema', id: 'LIST' }` is invalidated
              [{ type: "UserUdfCustomFieldDromoSchema", id: "LIST" }],
      }),
      updateUserUdfCustomField: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/user-custom-fields/${payload.id}/update/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: [{ type: "UserUdfCustomField", id: "LIST" }],
      }),
      deleteUserUdfCustomField: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/user-custom-fields/${payload.id}/delete/`,
          method: "POST",
        }),
        invalidatesTags: [{ type: "UserUdfCustomField", id: "LIST" }],
      }),
      fetchUserUdfCustomField: build.query({
        query: (payload) => `/api/v1/core/user-custom-fields/${payload.id}/`,
        transformResponse: (response) => transformResponse(response),
      }),
    }),
  });

export const {
  useAddUserUdfCustomFieldMutation,
  useFetchAllUserUdfCustomFieldsQuery,
  useFetchAllUserUdfCustomFieldsDromoSchemaQuery,
  useUpdateUserUdfCustomFieldMutation,
  useDeleteUserUdfCustomFieldMutation,
  useLazyFetchUserUdfCustomFieldQuery,
} = udfApi;
